import { BaseApiRouteService } from "mrb/core";

class CertifierDashboardApiRouteService extends BaseApiRouteService {
    constructor() {
        super("certifier-dashboard");
    }

    findCertifierModes(filter) {
        return super.find(`${this.base}/modes/{?searchQuery,isActive,page,rpp,sort,embed,fields}`, filter);
    }

    getSummary(modeId) {
        return super.get(`${this.base}/{modeId}/summary`, modeId, { propName: "modeId" });
    }

    findContent(modeId, filter) {
        return super.find(`${this.base}/{modeId}/content/find{?contentType,certificationStatus,searchQuery,page,rpp,sort,embed,fields}`, {
            modeId,
            ...filter,
        });
    }

    updateContentStatus(modeId, contentId) {
        return super.update(`${this.base}/{modeId}/content/{id}/status`, { modeId, id: contentId });
    }

    bulkUpdateContentStatus(modeId) {
        return super.update(`${this.base}/{modeId}/content/bulk-status`, { modeId });
    }
}

export default CertifierDashboardApiRouteService;
